// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family-main: 'Inter', sans-serif;

  --font-size-h1: 50px;
  --font-weight-h1: 600;
  --font-h1: var(--font-weight-h1) var(--font-size-h1) var(--font-family-main);

  --font-size-h2: 40px;
  --font-weight-h2: 600;
  --font-h2: var(--font-weight-h2) var(--font-size-h2) var(--font-family-main);

  --font-size-h3: 16px;
  --font-weight-h3: 700;
  --font-line-height-h3: 20px;
  --font-h3: var(--font-weight-h3) var(--font-size-h3) / var(--font-line-height-h3) var(--font-family-main);

  --font-size-h4: 30px;
  --font-weight-h4: 600;
  --font-h4: var(--font-weight-h4) var(--font-size-h4) var(--font-family-main);

  --font-size-main-min: 14px;
  --font-weight-main-min: 400;
  --font-main-min: var(--font-weight-main-min) var(--font-size-main-min) var(--font-family-main);

  --font-size-main: 16px;
  --font-weight-main: 400;
  --font-main: var(--font-weight-main) var(--font-size-main) var(--font-family-main);

  --font-size-main-max: 20px;
  --font-weight-main-max: 400;
  --font-main-max: var(--font-weight-main-max) var(--font-size-main-max) var(--font-family-main);

  --font-size-button: 16px;
  --font-weight-button: 700;
  --font-line-height-button: 30px;
  --font-button: var(--font-weight-button) var(--font-size-button) / var(--font-line-height-button) var(--font-family-main);

  --color-primary: #41c4c4;
  --color-secondary: #209090;
  --color-element-bg: #eeeeee;
  --color-surface: #ffffff;
  --color-disabled-bg: #dadada;
  --color-disabled-text: #b2b2b2;
  --color-black: #0e0e0e;
}

@media screen and (max-width: 1199px) {
  :root {
    --font-size-h1: 31px;
    --font-weight-h1: 600;

    --font-size-h2: 25px;
    --font-weight-h2: 600;

    --font-size-h3: 14px;
    --font-weight-h3: 700;
    --font-line-height-h3: 20px;

    --font-size-h4: 18px;
    --font-weight-h4: 600;

    --font-size-main-min: 12px;
    --font-weight-main-min: 400;

    --font-size-main: 14px;
    --font-weight-main: 400;

    --font-size-main-max: 16px;
    --font-weight-main-max: 400;
  }
}

@media screen and (max-width: 767px) {
  :root {
    --font-size-h1: 25px;
    --font-weight-h1: 600;

    --font-size-h2: 20px;
    --font-weight-h2: 600;

    --font-size-main-max: 14px;
    --font-weight-main-max: 400;

    --font-size-button: 14px;
    --font-weight-button: 700;
    --font-line-height-button: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/styles/variables/globals.css"],"names":[],"mappings":"AAEA;EACE,uCAAuC;;EAEvC,oBAAoB;EACpB,qBAAqB;EACrB,4EAA4E;;EAE5E,oBAAoB;EACpB,qBAAqB;EACrB,4EAA4E;;EAE5E,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,yGAAyG;;EAEzG,oBAAoB;EACpB,qBAAqB;EACrB,4EAA4E;;EAE5E,0BAA0B;EAC1B,2BAA2B;EAC3B,8FAA8F;;EAE9F,sBAAsB;EACtB,uBAAuB;EACvB,kFAAkF;;EAElF,0BAA0B;EAC1B,2BAA2B;EAC3B,8FAA8F;;EAE9F,wBAAwB;EACxB,yBAAyB;EACzB,+BAA+B;EAC/B,yHAAyH;;EAEzH,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;;IAErB,oBAAoB;IACpB,qBAAqB;;IAErB,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;;IAE3B,oBAAoB;IACpB,qBAAqB;;IAErB,0BAA0B;IAC1B,2BAA2B;;IAE3B,sBAAsB;IACtB,uBAAuB;;IAEvB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;;IAErB,oBAAoB;IACpB,qBAAqB;;IAErB,0BAA0B;IAC1B,2BAA2B;;IAE3B,wBAAwB;IACxB,yBAAyB;IACzB,+BAA+B;EACjC;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n:root {\n  --font-family-main: 'Inter', sans-serif;\n\n  --font-size-h1: 50px;\n  --font-weight-h1: 600;\n  --font-h1: var(--font-weight-h1) var(--font-size-h1) var(--font-family-main);\n\n  --font-size-h2: 40px;\n  --font-weight-h2: 600;\n  --font-h2: var(--font-weight-h2) var(--font-size-h2) var(--font-family-main);\n\n  --font-size-h3: 16px;\n  --font-weight-h3: 700;\n  --font-line-height-h3: 20px;\n  --font-h3: var(--font-weight-h3) var(--font-size-h3) / var(--font-line-height-h3) var(--font-family-main);\n\n  --font-size-h4: 30px;\n  --font-weight-h4: 600;\n  --font-h4: var(--font-weight-h4) var(--font-size-h4) var(--font-family-main);\n\n  --font-size-main-min: 14px;\n  --font-weight-main-min: 400;\n  --font-main-min: var(--font-weight-main-min) var(--font-size-main-min) var(--font-family-main);\n\n  --font-size-main: 16px;\n  --font-weight-main: 400;\n  --font-main: var(--font-weight-main) var(--font-size-main) var(--font-family-main);\n\n  --font-size-main-max: 20px;\n  --font-weight-main-max: 400;\n  --font-main-max: var(--font-weight-main-max) var(--font-size-main-max) var(--font-family-main);\n\n  --font-size-button: 16px;\n  --font-weight-button: 700;\n  --font-line-height-button: 30px;\n  --font-button: var(--font-weight-button) var(--font-size-button) / var(--font-line-height-button) var(--font-family-main);\n\n  --color-primary: #41c4c4;\n  --color-secondary: #209090;\n  --color-element-bg: #eeeeee;\n  --color-surface: #ffffff;\n  --color-disabled-bg: #dadada;\n  --color-disabled-text: #b2b2b2;\n  --color-black: #0e0e0e;\n}\n\n@media screen and (max-width: 1199px) {\n  :root {\n    --font-size-h1: 31px;\n    --font-weight-h1: 600;\n\n    --font-size-h2: 25px;\n    --font-weight-h2: 600;\n\n    --font-size-h3: 14px;\n    --font-weight-h3: 700;\n    --font-line-height-h3: 20px;\n\n    --font-size-h4: 18px;\n    --font-weight-h4: 600;\n\n    --font-size-main-min: 12px;\n    --font-weight-main-min: 400;\n\n    --font-size-main: 14px;\n    --font-weight-main: 400;\n\n    --font-size-main-max: 16px;\n    --font-weight-main-max: 400;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  :root {\n    --font-size-h1: 25px;\n    --font-weight-h1: 600;\n\n    --font-size-h2: 20px;\n    --font-weight-h2: 600;\n\n    --font-size-main-max: 14px;\n    --font-weight-main-max: 400;\n\n    --font-size-button: 14px;\n    --font-weight-button: 700;\n    --font-line-height-button: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
